module.exports = __webpack_public_path__ + "img/send.fe0c90ed.svg";